module.exports = __webpack_public_path__ + "static/media/menu.72f574ee.svg";